<template>
  <div class="contenedor">
    <v-dialog v-model="edicion" width="600px">
      <v-card style="overflow:hidden;">
        <v-card-title class="grey lighten-4 py-4 title"
          >Editar datos Usuario</v-card-title
        >
        <v-row justify="center">
          <v-col cols="8">
            <v-form ref="form_usuario" lazy-validation>
              <v-row class="align-center" justify="start" no-gutters>
                <v-col cols="6">
                  <v-row class="align-center" justify="start" no-gutters>
                    <v-col class="espacio" md="auto">Usuario:</v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="usuario"
                        readonly
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row class="align-center" justify="start" no-gutters>
                    <v-col class="espacio" md="auto">Categoría:</v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="categoria"
                        readonly
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-text-field
                v-model="nombre"
                :rules="[rules.required]"
                label="Nombre"
                required
              ></v-text-field>
              <v-text-field
                v-model="apellido"
                :rules="[rules.required]"
                label="Apellido"
                required
              ></v-text-field>
              <v-text-field
                v-model="mail"
                :rules="[rules.email]"
                label="E-mail"
                required
              ></v-text-field>
              <v-text-field
                v-model="pass"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="Contraseña"
                hint="Mínimo 8 digitos"
                counter
                @click:append="show1 = !show1"
                required
              ></v-text-field>
              <v-text-field
                v-model="pass2"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                name="input-10-1"
                label="Confirmar Contraseña"
                hint="Mínimo 8 digitos"
                counter
                @click:append="show2 = !show2"
                @keyup="compararClaves"
                required
              ></v-text-field>
              <template v-if="!pass_iguales">
                <v-row
                  class="text-md-center"
                  :class="pass_iguales ? 'ocultar_elemento' : ''"
                >
                  <v-col>
                    <label class="msj_pass"
                      >Las Contraseñas no coinciden...!</label
                    >
                  </v-col>
                </v-row>
              </template>
              <v-row justify-center>
                <v-col xs3 class="text-center">
                  <v-btn
                    class="mt-3 mb-3"
                    color="primary"
                    @click="edicion = false"
                    >Cancelar</v-btn
                  >
                </v-col>
                <v-col xs3 class="text-center">
                  <v-btn
                    class="mt-3 mb-3"
                    :disabled="!form_valido || !pass_iguales || cargando"
                    color="success"
                    @click="actualizarDatos"
                    >Guardar</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mostrarMsj" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Edición de Datos</v-card-title>
        <v-card-text>{{ msj_edicion }}</v-card-text>
        <!--<v-card-text>{{ adherirse_msj_2 }}</v-card-text>-->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="(mostrarMsj = false), logout()"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-dialog v-model="cargando" hide-overlay persistent width="300">
        <v-card color="#9c27b0" dark class="loading">
          <v-card-text>
            Espere un momento
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-row no-gutters justify="end">
      <v-col cols="12" class="pr-2">
        <v-row align="center" no-gutters justify="end">
          <v-col md="auto">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-avatar color="red" @click="mostrarVentan" v-on="on">
                  <span class="white--text headline">{{ inicial }}</span>
                </v-avatar>
              </template>
              <span>Editar Perfil</span>
            </v-tooltip>
          </v-col>
          <v-col class="ma-2 mb-0" justify="end" cols="8">
            <v-row no-gutters justify="end">
              <v-col cols="11">
                <em class="truncate">{{ nombre }} {{ apellido }}</em>
              </v-col>
            </v-row>
            <v-row no-gutters justify="end">
              <v-col cols="11">
                <em>Usuario: {{ usuario }}</em>
              </v-col>
            </v-row>
            <v-row no-gutters justify="end">
              <v-col cols="11">
                <em>{{ categoria }}</em>
              </v-col>
            </v-row>
            <v-row no-gutters justify="end">
              <v-col cols="11" class="pr-2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="logout">mdi-logout</v-icon>
                  </template>
                  <span>Cerrar Sesión</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <a @click="logout" v-on="on" class="pr-3">Salir</a>
                  </template>
                  <span>Cerrar Sesión</span>
                </v-tooltip>

                <v-badge
                  :content="messages"
                  :value="messages"
                  color="red"
                  overlap
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">mdi-email-outline</v-icon>
                    </template>
                    <span>Mensajes</span>
                  </v-tooltip>
                </v-badge>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import API from "../_config/conf";
export default {
  data() {
    return {
      messages: 1,
      idusuario: "",
      inicial: "",
      nombre_apellido: "",
      usuario: "",
      categoria: "",
      show1: false,
      show2: false,
      edicion: false,
      form_valido: true,
      pass_iguales: true,
      nombre: "",
      apellido: "",
      mail: "",
      pass: "",
      pass2: "",
      dni: "",
      rules: {
        required: value => !!value || "Campo Obligatorio.",
        min: v => (v && v.length >= 7) || "Mínimo 7 digitos",
        email: v => /.+@.+/.test(v) || "Debe ingresar un E-mail valido",
        caracteristica: v => (v && v.length >= 4) || "Mínimo 6 numeros",
        cel: v => (v && v.length >= 6) || "Mínimo 6 numeros",
        pass: API._rules.pass
      },
      cargando: false,
      mostrarMsj: false,
      msj_edicion: ""
    };
  },
  computed: {
    modo_oscuro: function() {
      return this.$vuetify.theme.isDark();
    }
  },
  mounted: function() {
    this.cargarDatos();
  },
  methods: {
    logout: function() {
      window.localStorage.removeItem("EPA_AUTH");
      document.location.href = "/login";
    },

    cambiarTema: function() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
    soloNumeros(e) {
      var key = window.event ? e.which : e.keyCode;
      if (key < 48 || key > 57) {
        e.preventDefault();
      }
    },
    compararClaves: function() {
      console.log("compararClaves->", this.form_valido);
      if (this.pass2 != "" && this.pass == this.pass2) this.pass_iguales = true;
      //return true;
      else {
        this.pass_iguales = false;
        //return false;
      }
    },
    cargarDatos: function() {
      let datosUsuario = window.localStorage.getItem("EPA_AUTH");

      if (datosUsuario != null) {
        try {
          var usuarioJson = JSON.parse(datosUsuario);
          this.nombre_apellido = API.ucFirst(
            usuarioJson.nombre + " " + usuarioJson.apellido
          );
          this.idusuario = API.ucFirst(usuarioJson.idusuario);
          this.nombre = API.ucFirst(usuarioJson.nombre);
          this.apellido = API.ucFirst(usuarioJson.apellido);
          this.usuario = usuarioJson.usuario;
          this.categoria = API.ucFirst(usuarioJson.categoria);
          this.dni = usuarioJson.usuario;
          this.mail = usuarioJson.mail;

          this.inicial = this.nombre.charAt(0);
        } catch (err) {
          console.log("catch", err);
          window.localStorage.removeItem("EPA_AUTH");
        }
      }
    },
    mostrarVentan: function() {
      this.edicion = true;
      this.form_valido = true;
      this.pass = "";
      this.pass2 = "";
      //console.log(this.$refs);
      if (this.$refs.form_usuario != undefined)
        this.$refs.form_usuario.resetValidation();
      this.cargarDatos();
    },
    actualizarDatos: function() {
      console.log("actualizarDatos");

      if (this.$refs.form_usuario.validate()) {
        if (this.pass != "" || this.pass2 != "") {
          this.compararClaves();
          if (this.pass_iguales) {
            //console.log("Formulario Correcto: ", this.form_valido);
            this.guardarDatosUsuario();
          } else {
            //console.log("Formulario Incorrecto: ", this.form_valido);
          }
        } else {
          //console.log("Formulario Correcto: ", this.form_valido);
          this.guardarDatosUsuario();
        }
      } else {
        this.form_valido = false;
        //console.log("Formulario Incorrecto Else: ", this.form_valido);
      }
      //console.log("form_valido: ", this.form_valido);
      /*console.log(this.nombre + " - ", this.apellido, " | mail: ", this.mail);
      console.log("pass: " + this.pass + " - pass2: ", this.pass2);
      console.log("OK");*/
    },
    guardarDatosUsuario: function() {
      this.cargando = true;

      let params =
        "idusuario=" +
        this.idusuario +
        "&nombre=" +
        this.nombre +
        "&apellido=" +
        this.apellido +
        "&dni=" +
        this.dni +
        "&mail=" +
        this.mail +
        "&pass=" +
        this.pass;

      //console.log("params: ", params);

      let result = API.enviar("get", "editarCuentaUsuario", params);
      result
        .then(result => {
          if (result.data.msj == "ok") {
            this.msj_edicion =
              "Los datos se actualizaron con éxito, para ver reflejados los cambios debe ingresar al sistema nuevamente !";
          }
        })
        .catch(error => {
          this.msj_edicion =
            "Oops! parece que ocurrió un problema al intentar guardar los cambios, por favor intente nuevamente... !!!";
          console.log("catch: ", error);
        })
        .finally(() => {
          this.cargando = false;
          this.mostrarMsj = true;
          console.log("finally");
        });
    }
  }
};
</script>

<style scoped>
.contenedor {
  width: 100%;
}

.col {
  text-align: right;
}

em {
  font-style: normal !important;
  font-size: 14px !important;
  color: #fff;
}

.mdi-logout {
  color: #fff;
}

.mdi-email-outline {
  color: #fff;
}

.v-badge {
  float: right;
  cursor: pointer;
}

a {
  color: #01df01 !important;
  font-weight: bold;
  text-decoration: underline;
}

.v-avatar {
  cursor: pointer !important;
}

.espacio {
  padding-right: 10px !important;
}

.truncate {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.msj_pass {
  color: red;
}
</style>